/*
Code for the Courses Page
*/

import React, { useState } from "react";
import {
  Accordion,
  Container,
  Form,
  Row,
  Col,
  Modal,
  Button,
} from "react-bootstrap";
import { FaExclamation } from "react-icons/fa";
import { Footer } from "./Footer";
import { Header } from "./Header";
import background from "./images/entrance.jpg";

export const Courses = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("all");
  const [showModal, setShowModal] = useState(false);
  const [showFirstSteps, setShowFirstSteps] = useState(false);
  const [showNumCourses, setShowNumCourses] = useState(false);
  const [showUnlisted, setShowUnlisted] = useState(false);
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [currentSheetIndex, setCurrentSheetIndex] = useState(0);
  const [showSearchResults, setShowSearchResults] = useState(false);

  const spreadsheets = [
    {
      embedLink:
        "https://docs.google.com/spreadsheets/d/e/2PACX-1vSdUgBwy-9toJSzUFlnEDK9fp6fbzawl2gXqSp_vQiUuj2XtHfgA0doeNRkRXDbij1yn7eD7nN1MyVx/pubhtml?gid=1807915379&single=true&widget=true&headers=false",
      shareLink:
        "https://docs.google.com/spreadsheets/d/1p7LXR3-JHJAnyRYnwKXHAiHNxUbH2IsFxa7qFTRiT84/edit?usp=sharing",
      name: "General 4 Year Plan",
    },
    {
      embedLink:
        "https://docs.google.com/spreadsheets/d/e/2PACX-1vSlMHMzDw8YNguMyhmv225O8wzGpjoFyv0o8vH2Qq3qzqPoFAY8tdaJYOGr0RlzpjUngPxntdDJcDo_/pubhtml?widget=true&amp;headers=false",
      shareLink:
        "https://docs.google.com/spreadsheets/d/1UG0ydoyIrr0yDgH4U6tE1fM9lC4FGiK96653sXZe_F8/edit?usp=sharing",
      name: "Math major/DS minor 4 year plan example (with GEs + GPA tracker) ",
    },
  ];

  const courses = [
    {
      code: "DS001 SC",
      name: "Introduction to Python and Data Analysis",
      description:
        "This course is the first part of a two-semester flipped-course introduction to computer programming, offered with the support of Google. Students will engage with interactive media to learn the fundamental programming constructs and data structures of Python (conditionals, loops, functions, lists, dictionaries, etc.) and use them to creatively design, test, and implement algorithms and programs while working on collaborative in-class projects based on real-world problems in graphics, image processing, cryptography, data analysis, astronomy, video games, and environmental simulation. Prior programming experience not required. This course is for non-CS majors only and does not fulfill the Scripps Math GE requirement.",
      prerequisites: "None",
      offered: "Every Fall",
      category: "programming",
    },
    {
      code: "MS059 SC",
      name: "Intro to Python and Viz",
      description:
        "This is an introduction to computer programming that supports Scripps College's interdisciplinary vision. It is for everyone–visual designers, data scientists, and fine artists–who wants to create interactive media and computer graphics. This course links software concepts to principles of visual form, motion, and interaction. Students learn the fundamentals of Python programming (data structures, sequencing, selection and sorting, iteration and recursion, functions, object-oriented code) and use Processing.py to analyze and visualize data, generate drawings and sounds, manipulate images, create interactions for games, use network communication to collect data, and learn how to work with remote data to create environmental simulations. Prior programming experience not required. This course satisfies the pre-requisite for DS2 in Scripps' Data Science minor",
      prerequisites: "None",
      offered: "Occasionally",
      category: "programming",
    },
    {
      code: "CSCI004 PZ ",
      name: "Intro to Comp Sci for Non-majors",
      description:
        "Introduction to elements of computer science. Students learn general computational problem-solving techniques and gain experience with the design, implementation, testing and documentation of programs in a high-level language. No prior programming experience required. Students may not earn credit for this course and any other intro level Computer Science course.",
      prerequisites: "None",
      offered: "Every Spring",
      category: "programming",
    },
    {
      code: "DS002 SC",
      name: "Foundations of Data Science",
      description:
        "This course is the second part of a two-semester flipped-course introduction to computer programming and data science. Students will explore, using Python and other tools (e.g., SQL), the nuances of gathering, visualizing and analyzing data to drive informed decision-making. Students will be introduced to use various data manipulation/analysis and machine learning libraries (pandas, scikit learn, etc.) and statistical methods. They will also consider the ethical implications and limitations of creating models to deal with large amounts of data efficiently. As in the first course, students will work collaboratively on in-class projects dealing with real-world datasets. This course does not satisfy the Scripps math major/minor, or Scripps Math GE.",
      prerequisites: "DS 001 SC or equivalent (knowledge of Python)",
      offered: "Every spring",
      category: "data_science",
    },
    {
      code: "BIOL174L KS",
      name: "Introduction to Biology Research Statistics",
      description:
        "This course introduces probability, experimental design and statistical analysis in biology and environmental science. The class includes a lab in which students apply basic and some advanced statistical approaches through programming in a language such as R. Skills important to computational research also will be developed. Students may take either Biology 174L or Biology 175, but not both. Course credit not available for students who have completed BIOL175.",
      prerequisites:
        "BIOL 043L KS and BIOL 044L KS; or BIOL042L KS and BIOL044L KS",
      offered: "Every year",
      category: "statistics",
    },
    {
      code: "BIOL175 KS",
      name: "Applied Biostatistics",
      description:
        "This lecture course provides an introduction to choosing, applying, and interpreting statistical analyses of biological data, with additional focus on experimental design and data presentation. Lectures are combined with hands-on computer time using statistical programs SPSS and R. Students may take either BIOL174L or BIOL175, but not both. Course credit not available for students who have completed BIOL174L",
      prerequisites: "BIOL 044L KS or BIOL043L KS or BIOL042L KS",
      offered: "Every semester",
      category: "statistics",
    },
    {
      code: "ECON120 SC",
      name: "Statistics",
      description:
        "Introduction to statistical analysis, focusing on causal relationships, experimental design, and statistical reasoning. The course develops tools for problem solving and interpretation of real-world data. Computer-based analysis of data rather than computational recipes will be emphasized.",
      prerequisites: "ECON 051 and ECON 052",
      offered: "Annually, check portal for exact offering",
      category: "statistics",
    },
    {
      code: "PSYC103 SC",
      name: "Psychological Statistics",
      description:
        "Introduction to the logic of hypothesis testing. Emphasis will be on basic statistical terms, gaining familiarity with computational procedures of both parametric and nonparametric techniques, and utilizing available computer programs for the analysis of data in the behavioral sciences.",
      prerequisites: "PSYC052 SC or equivalent",
      offered: "Annually",
      category: "statistics",
    },
    {
      code: "PSYC183 SC",
      name: "Data Science & Ethics",
      description:
        "Data science is a set of interdisciplinary approaches that seeks to construct or extract knowledge from large collections of information, and then to communicate that knowledge for the purposes of implementing scientific, economic, environmental, educational, or political policies. This course will give students insight into ethical challenges to and approaches in doing data science.",
      prerequisites: "None",
      offered: "Not specified",
      category: "data_science",
    },
    {
      code: "MATH60",
      name: "Linear Algebra",
      description:
        "This course emphasizes vector spaces and linear transformations. Topics include linear independence, bases, nullity and rank of a linear transformation, The Dimension Theorem, the representation of linear transformations as matrices, eigenvalues and eigenvectors, and determinants. Additional topics may include inner product spaces and Gram-Schmidt orthogonalization.",
      prerequisites: "Not specified",
      offered: "Not specified",
      category: "mathematics",
    },
    {
      code: "NEUR 133L KS",
      name: "Introduction to Computational Neuroscience",
      description:
        "In this course we study brains from two related perspectives: using computational tools to analyze complex data collected from brains, and considering how brains solve computationally challenging problems. Weekly group labs will build hands-on experience with concepts covered in lectures. Formerly BIOL133L KS.",
      prerequisites:
        "MATH030  SC and programming experience (such as a CS or DS course in college, high school, or online), or permission of instructor. Students must have a personal computer with internet access. For students who do not have a personal computer, please email instructor for other options",
      offered: "Every fall",
      category: "electives",
    },
    {
      code: "NEUR 182 SC",
      name: "Machine Learning Using Neural Signals",
      description:
        "This course teaches students the theory and practice of computational analyses of machine learning applied to neural signals for cognitive and neural classification. We will use real neural signals (e.g., spikes, EEG data, fMRI data, diffusion MRI data) in Python, Matlab, and R, so some computer programming experience is required (e.g., BIOL133L, PHYS108, PSYC123L, or equivalent). In this course, students will receive an overview of machine learning theory, an introduction to the concepts and practices of primary machine learning algorithms, and how to apply machine learning to information resulting from signal processing of neural signals. Each class meeting will involve theory and practical applications using active learning, giving students conceptual and computational capabilities that they can use for their own scholarly inquiry and computational applications.",
      prerequisites:
        "Prerequisites: Introduction to Computer Programming (preferably python or Matlab); Introduction to Probability and Statistics OR Calculus 2; Linear Algebra",
      offered: "Every year",
      category: "electives",
    },
    {
      code: "BIOL 138 KS",
      name: "Applied Ecology and Conservation",
      description:
        "This course covers advanced topics in population biology, community ecology, and population genetics as applied to conservation and resource management and with an emphasis on quantitative methods.",
      prerequisites: "BIOL044L KS or EA  030L  KS",
      offered: "Every year",
      category: "electives",
    },
    {
      code: "BIOL 138L KS",
      name: "Applied Ecology and Conservation Lab",
      description: "In this optional lab component to",
      prerequisites: "BIOL044L KS",
      offered: "Every year",
      category: "electives",
    },
    {
      code: "BIOL 174L KS",
      name: "Introduction to Biological Research Statistics",
      description:
        "This course introduces probability, experimental design and statistical analysis in biology and environmental science. The class includes a lab in which students apply basic and some advanced statistical approaches through programming in a language such as R. Skills important to computational research also will be developed.\u00a0 Students may take either Biology 174L or Biology 175, but not both. Course credit not available for students who have completed BIOL175.",
      prerequisites: "BIOL 043L and BIOL 044L ; or BIOL042L KS and BIOL044L KS",
      offered: "Every year",
      category: "electives",
    },
    {
      code: "BIOL 175 KS",
      name: "Applied Biostatistics",
      description:
        "This lecture course provides an introduction to choosing, applying, and interpreting statistical analyses of biological data, with additional focus on experimental design and data presentation. Lectures are combined with hands-on computer time using statistical programs SPSS and R. Students may take either BIOL174L or BIOL175, but not both. Course credit not available for students who have completed BIOL174L.",
      prerequisites: "BIOL 044L or BIOL043L KS or BIOL042L KS",
      offered: "Both semesters",
      category: "electives",
    },
    {
      code: "BIOL 184L KS",
      name: "Disease Ecology and Evolution",
      description:
        "This class will cover the biology of infectious diseases spanning from the cellular to ecosystem scales, ranging from human to sea star hosts, and covering ecological to evolutionary time frames. While some basics of parasitology and immunology will be introduced, the course will focus on the ecology and evolution of host-parasite interactions. Topics will include: defense and virulence, ecological roles of parasites, epidemiology and disease modeling, infection heterogeneity, and host-parasite coevolution. Effects of the Anthropocene on infectious diseases (e.g. globalization, invasive species, antibiotic use) will also be a major theme.",
      prerequisites: "BIOL 044L and either BIOL 043L or EA  030L  KS",
      offered: "Every year",
      category: "electives",
    },
    {
      code: "MATH 055 SC",
      name: "Discrete Mathematics",
      description:
        "Topics include combinatorics, number theory, and graph theory with an emphasis on creative problem solving and learning to read and write rigorous proofs. Possible applications include probability, analysis of algorithms, and cryptography.",
      prerequisites: "MATH 031   MATH 060",
      offered: "Occasionally",
      category: "electives",
    },
    {
      code: "MATH 101 SC",
      name: "Introduction to Analysis",
      description:
        "This is a workshop course on how to write proofs in the context of analysis, with a focus on the construction and presentation of rigorous proofs. Students will learn how to use the language of analysis to prove results about sequences, limits, and continuity. Students will regularly present proofs in both written and oral form.",
      prerequisites: "MATH 032 or MATH 060 .",
      offered: "Not specified",
      category: "electives",
    },
    {
      code: "MATH 102 SC",
      name: "Differential Equations and Modeling",
      description:
        "In this course we will introduce some basic models including Lotka-Volterra (Predator-Prey) models, as well as some standard modeling techniques. The emphasis in the course will be placed on qualitative methods and the use of software to understand solutions. Eigenvalues and eigenvectors will be introduced to fully solve linear systems in the plane. Linear and non-linear systems of differential equations will be analyzed by classifying orbits near fixed-point solutions. Students may not receive credit for both MATH 102 and",
      prerequisites: "MATH 032 .  MATH 060 .",
      offered: "Every spring",
      category: "electives",
    },
    {
      code: "MATH 131 SC",
      name: "Principles of Analysis",
      description:
        "This course is the first half of a rigorous discussion of the main concepts (convergence, continuity, differentiation, and integration) of analysis. It begins with basic topology (openness, compactness, completeness, etc.) in metric spaces and a precise treatment of numerical sequences and series and closes with uniform convergence and the great theorems of Ascoli-Arzel\u00e0 and Stone-Weierstrass.",
      prerequisites: "MATH 032 , MATH 060 . Recommended: MATH 101 .",
      offered: "Not specified",
      category: "electives",
    },
    {
      code: "MATH 139 SC",
      name: "Fourier Analysis",
      description:
        "Fourier analysis begins with the examination of the difficulties involved in attempting to reconstruct arbitrary functions as infinite combinations of elementary trigonometric functions. Topics in this course will include Fourier series, summability, types and questions of convergence, and the Fourier transform (with, if time permits, applications to PDEs, medical imaging, linguistics, and number theory).",
      prerequisites: "MATH 131 .",
      offered: "Not specified",
      category: "electives",
    },
    {
      code: "MATH 183 SC",
      name: "Modeling and Simulation",
      description:
        "This course is an introduction to mathematical models with deterministic and stochastic dynamics and with discrete and continuous time. Students will learn the mathematical analysis and numerical simulations for these models, and then present their results in both written and verbal forms. The models will be applied to various applications.",
      prerequisites: "MATH060  SC , MATH102  SC , or MATH111  SC .",
      offered: "Occasionally",
      category: "electives",
    },
    {
      code: "MATH 185 SC",
      name: "Methods in Modern Modeling",
      description:
        "Models are applied on a daily basis to provide insight into any number of current world problems. From diseases to government policy, modeling techniques are being used to predict outcomes and manage populations. With the advent of more computational power and data collection, novel model types and techniques for analysis are being derived. We will explore current models and techniques which are used across multiple disciplines. We will consider agent-based (or individual-based) modeling, and ordinary differential equation models with parameter estimation, along with additional topics. Students will have a chance to investigate using analytical and computational skills, that can be applied across a diversity of fields.",
      prerequisites:
        "MATH183 SC\u00a0or MATH102/111 and MATH151)\u00a0; or by permission of instructor.",
      offered: "Occasionally",
      category: "electives",
    },
    {
      code: "ECON 125 SC",
      name: "Econometrics",
      description:
        "Statistical techniques for testing economic models and evaluating data. Includes regression models, time series, and cross-section data analysis. Offered annually.",
      prerequisites: "ECON 101 and ECON 120 .",
      offered: "Not specified",
      category: "electives",
    },
    {
      code: "PSYC 103 SC",
      name: "Psychological Statistics",
      description:
        "Introduction to the logic of hypothesis testing. Emphasis will be on basic statistical terms, gaining familiarity with computational procedures of both parametric and nonparametric techniques, and utilizing available computer programs for the analysis of data in the behavioral sciences.",
      prerequisites: "PSYC052  SC or equivalent.",
      offered: "Every year",
      category: "electives",
    },
    {
      code: "PSYC 183 SC",
      name: "Data Science Ethics & Justice",
      description:
        "Data science is a set of interdisciplinary approaches that seeks to construct or extract knowledge from large collections of information, and then to communicate that knowledge for the purposes of implementing scientific, economic, environmental, educational, or political policies. This course will give students insight into ethical challenges to and approaches in doing data science.",
      prerequisites: "None",
      offered: "Every spring",
      category: "electives",
    },
    {
      code: "PSYC 182 SC",
      name: "Machine Learning Using Neural Signals",
      description:
        "This course teaches students the theory and practice of computational analyses of machine learning applied to neural signals for cognitive and neural classification. We will use real neural signals (e.g., spikes, EEG data, fMRI data, diffusion MRI data) in Python, Matlab, and R, so some computer programming experience is required (e.g., BIOL133L, PHYS108, PSYC123L, or equivalent). In this course, students will receive an overview of machine learning theory, an introduction to the concepts and practices of primary machine learning algorithms, and how to apply machine learning to information resulting from signal processing of neural signals. Each class meeting will involve theory and practical applications using active learning, giving students conceptual and computational capabilities that they can use for their own scholarly inquiry and computational applications.",
      prerequisites:
        "Prerequisites: Introduction to Computer Programming (preferably python or Matlab); Introduction to Probability and Statistics OR Calculus 2; Linear Algebra",
      offered: "Every year",
      category: "electives",
    },
    {
      code: "PHYS 178 KS",
      name: "Biophysics",
      description:
        "An examination of biological systems from the point of view of classical physics, including mechanics, thermodynamics, and electromagnetism. Topics may include molecular diffusion, low-Reynolds number hydrodynamics, cooperative transitions in biomolecules, the mechanism of nerve impulses, the physics of vision and hearing, and principles of medical imaging and radiation therapy.",
      prerequisites:
        "BIOL 043L , or , or BIOL042L KS ; CHEM 014L and CHEM 015L , or and CHEM 015L , or CHEM 029L , or CHEM042L KS ; and PHYS 030L , PHYS 031L or PHYS 033L , PHYS 034L , or permission of instructor.",
      offered: "Every other spring",
      category: "electives",
    },
    {
      code: "MATH 030 SC",
      name: "Calculus I",
      description:
        "MATH 030 is the first course of a standard three course sequence in calculus. The topics covered include differentiation, integration, mean value theorem, transcendental functions, and trigonometric functions.",
      prerequisites: "MATH 023 or placement examination",
      offered: "Every semester",
      category: "prerequisites",
    },
    {
      code: "MATH 031 SC",
      name: "Calculus II",
      description:
        "This is the second course of a standard three-course sequence in calculus. Topics covered include techniques and applications of integration, infinite series, power series and an introduction to differential equations.",
      prerequisites: "MATH 030 or placement examination",
      offered: "Every semester",
      category: "prerequisites",
    },
  ];

  const handleNext = () => {
    setCurrentSheetIndex((prevIndex) =>
      prevIndex === spreadsheets.length - 1 ? 0 : prevIndex + 1
    );
  };

  const handlePrevious = () => {
    setCurrentSheetIndex((prevIndex) =>
      prevIndex === 0 ? spreadsheets.length - 1 : prevIndex - 1
    );
  };

  const handleShowModal = (course) => {
    setSelectedCourse(course);
    setShowModal(true);
  };

  const handleShowFirstSteps = () => {
    setShowFirstSteps(true);
  };

  const handleShowNumCourses = () => {
    setShowNumCourses(true);
  };

  const handleShowUnlisted = () => {
    setShowUnlisted(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setShowFirstSteps(false);
    setShowNumCourses(false);
    setShowUnlisted(false);
    setSelectedCourse(null);
  };

  const filteredCourses = courses.filter(
    (course) =>
      (course.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        course.code.toLowerCase().includes(searchTerm.toLowerCase()) ||
        course.description.toLowerCase().includes(searchTerm.toLowerCase()) ||
        course.prerequisites
          .toLowerCase()
          .includes(searchTerm.toLowerCase())) &&
      (selectedCategory === "all" || course.category === selectedCategory)
  );

  return (
    <div>
      <Header />
      <article className="page-header">
        <img className="header-img" src={background} alt="background" />
        <h1 className="header-img-caption">Courses</h1>
        <p className="header-img-text">
          Five core areas and two upper division electives
        </p>
      </article>
      <div className="space1" />
      <Container>
        <Row>
          <Col>
            <h2 className="important-text">Important:</h2>
          </Col>
          <Col md={6}>
            <p>
              {" "}
              Prospective data science minors should contact a Data Science
              professor before junior year, or after taking Foundations of Data
              Science. This is to verify that your courses will in fact count
              for the minor.{" "}
            </p>
          </Col>
          <Col>
            <FaExclamation className="important-icon" size={80} />
          </Col>
          <div className="space2" />
          <Row>
            <Col>
              <Button
                className="linked-button"
                onClick={() => handleShowFirstSteps()}
              >
                First Steps
              </Button>
            </Col>
            <Col>
              <Button
                className="linked-button"
                onClick={() => handleShowNumCourses()}
              >
                Total Number of Courses
              </Button>
            </Col>
            <Col>
              <Button
                className="linked-button"
                href="https://catalog.scrippscollege.edu/content.php?catoid=33&navoid=4198#Double_Counting_Courses"
                target="_blank"
                rel="noreferrer"
              >
                Double Counting Rules
              </Button>
            </Col>
            <Col>
              <Button
                className="linked-button"
                onClick={() => handleShowUnlisted()}
              >
                Unlisted Courses
              </Button>
            </Col>
            <div className="space1" />
          </Row>
        </Row>
      </Container>
      <div className="decor-bar">
        <h2 className="home-title"> Curriculum</h2>
      </div>
      <Container>
        <div className="space1" />
        <Row className="mb-4">
          <Col md={8}>
            <div className="search-container">
              <Form.Control
                type="text"
                placeholder="Search courses by code, name, or keywords..."
                value={searchTerm}
                onChange={(e) => {
                  setSearchTerm(e.target.value);
                  setShowSearchResults(e.target.value.length > 0);
                }}
              />
              {showSearchResults && (
                <div className="search-results-popup">
                  {filteredCourses.length > 0 ? (
                    <ul>
                      {filteredCourses.map((course, index) => (
                        <li key={index} onClick={() => handleShowModal(course)}>
                          {course.code}: {course.name}
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <p>No matching courses found.</p>
                  )}
                </div>
              )}
            </div>
          </Col>
          <Col md={4}>
            <Form.Select
              value={selectedCategory}
              onChange={(e) => setSelectedCategory(e.target.value)}
            >
              <option value="all">All Categories</option>
              <option value="prerequisites">Prerequisites</option>
              <option value="programming">Programming</option>
              <option value="electives">Electives</option>
            </Form.Select>
          </Col>
        </Row>

        <h2>Prerequisites</h2>
        <Accordion className="resource_accordion">
          <Accordion.Item eventKey="0">
            <Accordion.Header>MATH030 SC: Calculus I</Accordion.Header>
            <Accordion.Body>
              <p>
                MATH 030 is the first course of a standard three course sequence
                in calculus. The topics covered include differentiation,
                integration, mean value theorem, transcendental functions, and
                trigonometric functions.
              </p>
              <p>
                <strong>Prerequisites:</strong> MATH 023 or placement
                examination.
              </p>
              <p>
                <strong>Offered:</strong> Every semester
              </p>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="1">
            <Accordion.Header>MATH031 SC: Calculus II</Accordion.Header>
            <Accordion.Body>
              <p>
                This is the second course of a standard three-course sequence in
                calculus. Topics covered include techniques and applications of
                integration, infinite series, power series and an introduction
                to differential equations.
              </p>
              <p>
                <strong>Prerequisites:</strong> MATH 030 or placement
                examination.
              </p>
              <p>
                <strong>Offered:</strong> Every semester
              </p>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
        <div className="space1" />
        <h2>Five Core Areas</h2>
        <Accordion className="resource_accordion">
          <Accordion.Item eventKey="0">
            <Accordion.Header>Intro to Computer Programming</Accordion.Header>
            <Accordion.Body>
              <p>
                The below courses are the only ones accepted for the minor –
                substitute courses must be approved by your advisor before you
                register!
              </p>
              <ul>
                {[
                  {
                    code: "DS001 SC ",
                    name: "Introduction to Python and Data Analysis",
                    description:
                      "This course is the first part of a two-semester flipped-course introduction to computer programming, offered with the support of Google. Students will engage with interactive media to learn the fundamental programming constructs and data structures of Python (conditionals, loops, functions, lists, dictionaries, etc.) and use them to creatively design, test, and implement algorithms and programs while working on collaborative in-class projects based on real-world problems in graphics, image processing, cryptography, data analysis, astronomy, video games, and environmental simulation. Prior programming experience not required. This course is for non-CS majors only and does not fulfill the Scripps Math GE requirement.",
                    prerequisites: "None",
                    offered: "Every Fall",
                  },
                  {
                    code: " MS059 SC  ",
                    name: "Intro to Python and Viz",
                    description:
                      "This is an introduction to computer programmingthat supports Scripps College’s interdisciplinary vision. It is foreveryone–visual designers, data scientists, and fine artists–who wantsto create interactive media and computergraphics. This course links software conceptsto principles of visual form, motion, and interaction. Students learn thefundamentals of Python programming (data structures, sequencing, selection and sorting, iteration and recursion,functions, object-orientedcode) and use Processing.pyto analyze and visualize data, generate drawings andsounds, manipulate images,create interactions for games, use network communicationto collect data, and learnhow to work with remote data to create environmental simulations.Prior programming experience not required. This course satisfies the pre-requisite for DS2 in Scripps’ Data Science minor",
                    prerequisites: "None",
                    offered: "Occasionally",
                  },
                  {
                    code: "CSCI004 PZ ",
                    name: "Intro to Comp Sci for Non-majors",
                    description:
                      "Introduction to elements of computer science. Students learn general computational problem-solving techniques and gain experience with the design, implementation, testing and documentation of programs in a high-level language. No prior programming experience required. Students may not earn credit for this course and any other intro level Computer Science course.",
                    prerequisites: "None",
                    offered: "Every Spring",
                  },
                ].map((course, index) => (
                  <li key={index}>
                    <span
                      onClick={() => handleShowModal(course)}
                      style={{
                        cursor: "pointer",
                        textDecoration: "underline",
                      }}
                    >
                      {course.code} - {course.name}
                    </span>
                  </li>
                ))}
              </ul>
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="1">
            <Accordion.Header>
              DS002 SC: Foundations of Data Science
            </Accordion.Header>
            <Accordion.Body>
              <p>
                This course is the second part of a two-semester flipped-course
                introduction to computer programming and data science. Students
                will explore, using Python and other tools (e.g., SQL), the
                nuances of gathering, visualizing and analyzing data to drive
                informed decision-making. Students will be introduced to use
                various data manipulation/analysis and machine learning
                libraries (pandas, scikit learn, etc.) and statistical methods.
                They will also consider the ethical implications and limitations
                of creating models to deal with large amounts of data
                efficiently. As in the first course, students will work
                collaboratively on in-class projects dealing with real-world
                datasets. This course does not satisfy the Scripps math
                major/minor, or Scripps Math GE.
              </p>
              <p>
                <strong>Prerequisites:</strong> DS 001 SC or equivalent
                (knowledge of Python).
              </p>
              <p>
                <strong>Offered:</strong> Every spring
              </p>
              <div className="alert alert-info mt-4">
                <p>
                  You must take this class – there are no off-campus equivalents
                  that are accepted. After you take this class, it is{" "}
                  <strong>strongly</strong> recommended that you meet with a
                  member of the DS faculty before proceeding with the minor, if
                  you have not already.
                </p>
              </div>
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="2">
            <Accordion.Header>Probability and Statistics</Accordion.Header>
            <Accordion.Body>
              <p>
                The below courses are the only ones accepted for the minor –
                substitute courses must be approved by your advisor before you
                register!{" "}
              </p>
              <ul>
                {[
                  {
                    code: "BIOL174L KS",
                    name: "Introduction to Biology Research Statistics",
                    description:
                      "This course introduces probability, experimental design and statistical analysis in biology and environmental science. The class includes a lab in which students apply basic and some advanced statistical approaches through programming in a language such as R. Skills important to computational research also will be developed.  Students may take either Biology 174L or Biology 175, but not both. Course credit not available for students who have completed BIOL175.",
                    prerequisites:
                      "BIOL 043L KS and BIOL 044L KS; or BIOL042L KS and BIOL044L KS",
                    offered: "Every year",
                  },
                  {
                    code: "BIOL175 KS",
                    name: "Applied Biostatistics",
                    description:
                      "This lecture course provides an introduction to choosing, applying, and interpreting statistical analyses of biological data, with additional focus on experimental design and data presentation. Lectures are combined with hands-on computer time using statistical programs SPSS and R. Students may take either BIOL174L or BIOL175, but not both. Course credit not available for students who have completed BIOL174L",
                    prerequisites: "BIOL 044L KS or BIOL043L KS or BIOL042L KS",
                    offered: "Every semester",
                  },
                  {
                    code: "ECON120 SC",
                    name: "Statistics",
                    description:
                      "Introduction to statistical analysis, focusing on causal relationships, experimental design, and statistical reasoning. The course develops tools for problem solving and interpretation of real-world data. Computer-based analysis of data rather than computational recipes will be emphasized.",
                    prerequisites: "ECON 051 and ECON 052.",
                    offered: "Annually, check portal for exact offering",
                  },
                  {
                    code: "PSYC103 SC",
                    name: "Psychological Statistics",
                    description:
                      "Introduction to the logic of hypothesis testing. Emphasis will be on basic statistical terms, gaining familiarity with computational procedures of both parametric and nonparametric techniques, and utilizing available computer programs for the analysis of data in the behavioral sciences. ",
                    prerequisites: "PSYC052 SC or equivalent",
                    offered: "Annually",
                  },
                ].map((course, index) => (
                  <li key={index}>
                    <span
                      onClick={() => handleShowModal(course)}
                      style={{
                        cursor: "pointer",
                        textDecoration: "underline",
                      }}
                    >
                      {course.code} - {course.name}
                    </span>
                  </li>
                ))}
              </ul>
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="3">
            <Accordion.Header>
              PSYC183 SC: Data Science & Ethics
            </Accordion.Header>
            <Accordion.Body>
              <p>
                Data science is a set of interdisciplinary approaches that seeks
                to construct or extract knowledge from large cconomic,
                environmental, educational, or political policies. This course
                will give students insight into ethical challenges to and
                approaches in doing data science.
              </p>
              <p>
                <strong>Prerequisite(s):</strong> None
              </p>
              <div className="alert alert-info mt-4">
                <p>
                  You must take this course – there are no off-campus
                  equivalents that are accepted.
                </p>
              </div>
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="4">
            <Accordion.Header>MATH60: Linear Algebra</Accordion.Header>
            <Accordion.Body>
              <p>
                This course emphasizes vector spaces and linear transformations.
                Topics include linear independence, bases, nullity and rank of a
                linear transformation, The Dimension Theorem, the representation
                of linear transformations as matrices, eigenvalues and
                eigenvectors, and determinants. Additional topics may include
                inner product spaces and Gram-Schmidt orthogonalization.
              </p>
              <div className="alert alert-info mt-4">
                <p>
                  Multiple campuses offer this class with the code MATH60. Note
                  - many students take this class without taking MATH32: Calulus
                  III. Taking Calculus III will not majorly complement your
                  understanding of Linear Algebra either.
                </p>
              </div>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>

        <div className="space1" />

        <h2>Two Upper Division Electives</h2>
        <Accordion className="resource_accordion">
          <Accordion.Item eventKey="0">
            <Accordion.Header>Upper Division Electives</Accordion.Header>
            <Accordion.Body>
              <p>
                Upper division courses should be numbered 100 and above or
                approved by a Data Science minor adviser. Study abroad courses
                can fulfill these requirements. This list is NOT fully
                comprehensive, speak with an advisor to approve study abroad or
                additional 5C courses.
              </p>
              <p>
                <strong>Neuroscience</strong>
              </p>
              <ul>
                {[
                  {
                    code: "NEUR 133L KS",
                    name: "Introduction to Computational Neuroscience",
                    description:
                      "In this course we study brains from two related perspectives: using computational tools to analyze complex data collected from brains, and considering how brains solve computationally challenging problems. Weekly group labs will build hands-on experience with concepts covered in lectures. Formerly BIOL133L KS.",
                    prerequisites:
                      "MATH030  SC and programming experience (such as a CS or DS course in college, high school, or online), or permission of instructor. Students must have a personal computer with internet access. For students who do not have a personal computer, please email instructor for other options",
                    offered: "Every fall",
                  },
                  {
                    code: "NEUR 182 SC",
                    name: "Machine Learning Using Neural Signals",
                    description:
                      "This course teaches students the theory and practice of computational analyses of machine learning applied to neural signals for cognitive and neural classification. We will use real neural signals (e.g., spikes, EEG data, fMRI data, diffusion MRI data) in Python, Matlab, and R, so some computer programming experience is required (e.g., BIOL133L, PHYS108, PSYC123L, or equivalent). In this course, students will receive an overview of machine learning theory, an introduction to the concepts and practices of primary machine learning algorithms, and how to apply machine learning to information resulting from signal processing of neural signals. Each class meeting will involve theory and practical applications using active learning, giving students conceptual and computational capabilities that they can use for their own scholarly inquiry and computational applications.",
                    prerequisites:
                      "Prerequisites: Introduction to Computer Programming (preferably python or Matlab); Introduction to Probability and Statistics OR Calculus 2; Linear Algebra",
                    offered: "Every year",
                  },
                ].map((course, index) => (
                  <li key={index}>
                    <span
                      onClick={() => handleShowModal(course)}
                      style={{
                        cursor: "pointer",
                        textDecoration: "underline",
                      }}
                    >
                      {course.code} - {course.name}
                    </span>
                  </li>
                ))}
              </ul>

              <p>
                <strong>Biology</strong>
              </p>
              <ul>
                {[
                  {
                    code: "BIOL 138 KS",
                    name: "Applied Ecology and Conservation",
                    description:
                      "This course covers advanced topics in population biology, community ecology, and population genetics as applied to conservation and resource management and with an emphasis on quantitative methods.",
                    prerequisites: "BIOL044L KS or EA  030L  KS",
                    offered: "Every year",
                  },
                  {
                    code: "BIOL 138L KS",
                    name: "Applied Ecology and Conservation Lab",
                    description: "In this optional lab component to",
                    prerequisites: "BIOL044L KS",
                    offered: "Every year",
                  },
                  {
                    code: "BIOL 174L KS",
                    name: "Introduction to Biological Research Statistics",
                    description:
                      "This course introduces probability, experimental design and statistical analysis in biology and environmental science. The class includes a lab in which students apply basic and some advanced statistical approaches through programming in a language such as R. Skills important to computational research also will be developed.\u00a0 Students may take either Biology 174L or Biology 175, but not both. Course credit not available for students who have completed BIOL175.",
                    prerequisites:
                      "BIOL 043L and BIOL 044L ; or BIOL042L KS and BIOL044L KS",
                    offered: "Every year",
                  },
                  {
                    code: "BIOL 175 KS",
                    name: "Applied Biostatistics",
                    description:
                      "This lecture course provides an introduction to choosing, applying, and interpreting statistical analyses of biological data, with additional focus on experimental design and data presentation. Lectures are combined with hands-on computer time using statistical programs SPSS and R. Students may take either BIOL174L or BIOL175, but not both. Course credit not available for students who have completed BIOL174L.",
                    prerequisites: "BIOL 044L or BIOL043L KS or BIOL042L KS",
                    offered: "Both semesters",
                  },
                  {
                    code: "BIOL 184L KS",
                    name: "Disease Ecology and Evolution",
                    description:
                      "This class will cover the biology of infectious diseases spanning from the cellular to ecosystem scales, ranging from human to sea star hosts, and covering ecological to evolutionary time frames. While some basics of parasitology and immunology will be introduced, the course will focus on the ecology and evolution of host-parasite interactions. Topics will include: defense and virulence, ecological roles of parasites, epidemiology and disease modeling, infection heterogeneity, and host-parasite coevolution. Effects of the Anthropocene on infectious diseases (e.g. globalization, invasive species, antibiotic use) will also be a major theme.",
                    prerequisites:
                      "BIOL 044L and either BIOL 043L or EA  030L  KS",
                    offered: "Every year",
                  },
                ].map((course, index) => (
                  <li key={index}>
                    <span
                      onClick={() => handleShowModal(course)}
                      style={{
                        cursor: "pointer",
                        textDecoration: "underline",
                      }}
                    >
                      {course.code} - {course.name}
                    </span>
                  </li>
                ))}
              </ul>

              <p>
                <strong>Math</strong>
              </p>
              <ul>
                {[
                  {
                    code: "MATH 055 SC",
                    name: "Discrete Mathematics",
                    description:
                      "Topics include combinatorics, number theory, and graph theory with an emphasis on creative problem solving and learning to read and write rigorous proofs. Possible applications include probability, analysis of algorithms, and cryptography.",
                    prerequisites: "MATH 031   MATH 060",
                    offered: "Occasionally",
                  },
                  {
                    code: "MATH 101 SC",
                    name: "Introduction to Analysis",
                    description:
                      "This is a workshop course on how to write proofs in the context of analysis, with a focus on the construction and presentation of rigorous proofs. Students will learn how to use the language of analysis to prove results about sequences, limits, and continuity. Students will regularly present proofs in both written and oral form.",
                    prerequisites: "MATH 032 or MATH 060 .",
                    offered: "Not specified",
                  },
                  {
                    code: "MATH 102 SC",
                    name: "Differential Equations and Modeling",
                    description:
                      "In this course we will introduce some basic models including Lotka-Volterra (Predator-Prey) models, as well as some standard modeling techniques. The emphasis in the course will be placed on qualitative methods and the use of software to understand solutions. Eigenvalues and eigenvectors will be introduced to fully solve linear systems in the plane. Linear and non-linear systems of differential equations will be analyzed by classifying orbits near fixed-point solutions. Students may not receive credit for both MATH 102 and",
                    prerequisites: "MATH 032 .  MATH 060 .",
                    offered: "Every spring",
                  },
                  {
                    code: "MATH 131 SC",
                    name: "Principles of Analysis",
                    description:
                      "This course is the first half of a rigorous discussion of the main concepts (convergence, continuity, differentiation, and integration) of analysis. It begins with basic topology (openness, compactness, completeness, etc.) in metric spaces and a precise treatment of numerical sequences and series and closes with uniform convergence and the great theorems of Ascoli-Arzel\u00e0 and Stone-Weierstrass.",
                    prerequisites:
                      "MATH 032 , MATH 060 . Recommended: MATH 101 .",
                    offered: "Not specified",
                  },
                  {
                    code: "MATH 139 SC",
                    name: "Fourier Analysis",
                    description:
                      "Fourier analysis begins with the examination of the difficulties involved in attempting to reconstruct arbitrary functions as infinite combinations of elementary trigonometric functions. Topics in this course will include Fourier series, summability, types and questions of convergence, and the Fourier transform (with, if time permits, applications to PDEs, medical imaging, linguistics, and number theory).",
                    prerequisites: "MATH 131 .",
                    offered: "Not specified",
                  },
                  {
                    code: "MATH 183 SC",
                    name: "Modeling and Simulation",
                    description:
                      "This course is an introduction to mathematical models with deterministic and stochastic dynamics and with discrete and continuous time. Students will learn the mathematical analysis and numerical simulations for these models, and then present their results in both written and verbal forms. The models will be applied to various applications.",
                    prerequisites:
                      "MATH060  SC , MATH102  SC , or MATH111  SC .",
                    offered: "Occasionally",
                  },
                  {
                    code: "MATH 185 SC",
                    name: "Methods in Modern Modeling",
                    description:
                      "Models are applied on a daily basis to provide insight into any number of current world problems. From diseases to government policy, modeling techniques are being used to predict outcomes and manage populations. With the advent of more computational power and data collection, novel model types and techniques for analysis are being derived. We will explore current models and techniques which are used across multiple disciplines. We will consider agent-based (or individual-based) modeling, and ordinary differential equation models with parameter estimation, along with additional topics. Students will have a chance to investigate using analytical and computational skills, that can be applied across a diversity of fields.",
                    prerequisites:
                      "MATH183 SC\u00a0or MATH102/111 and MATH151)\u00a0; or by permission of instructor.",
                    offered: "Occasionally",
                  },
                ].map((course, index) => (
                  <li key={index}>
                    <span
                      onClick={() => handleShowModal(course)}
                      style={{
                        cursor: "pointer",
                        textDecoration: "underline",
                      }}
                    >
                      {course.code} - {course.name}
                    </span>
                  </li>
                ))}
              </ul>

              <p>
                <strong>Economics</strong>
              </p>
              <ul>
                {[
                  {
                    code: "ECON 120 SC",
                    name: "Statistics",
                    description:
                      "Introduction to statistical analysis, focusing on causal relationships, experimental design, and statistical reasoning. The course develops tools for problem solving and interpretation of real-world data. Computer-based analysis of data rather than computational recipes will be emphasized. Offered annually.",
                    prerequisites: "ECON 051 and ECON 052 .",
                    offered: "Not specified",
                  },
                  {
                    code: "ECON 125 SC",
                    name: "Econometrics",
                    description:
                      "Statistical techniques for testing economic models and evaluating data. Includes regression models, time series, and cross-section data analysis. Offered annually.",
                    prerequisites: "ECON 101 and ECON 120 .",
                    offered: "Not specified",
                  },
                ].map((course, index) => (
                  <li key={index}>
                    <span
                      onClick={() => handleShowModal(course)}
                      style={{
                        cursor: "pointer",
                        textDecoration: "underline",
                      }}
                    >
                      {course.code} - {course.name}
                    </span>
                  </li>
                ))}
              </ul>

              <p>
                <strong>Psychology</strong>
              </p>
              <ul>
                {[
                  {
                    code: "PSYC 103 SC",
                    name: "Psychological Statistics",
                    description:
                      "Introduction to the logic of hypothesis testing. Emphasis will be on basic statistical terms, gaining familiarity with computational procedures of both parametric and nonparametric techniques, and utilizing available computer programs for the analysis of data in the behavioral sciences.",
                    prerequisites: "PSYC052  SC or equivalent.",
                    offered: "Every year",
                  },
                  {
                    code: "PSYC 183 SC",
                    name: "Data Science Ethics & Justice",
                    description:
                      "Data science is a set of interdisciplinary approaches that seeks to construct or extract knowledge from large collections of information, and then to communicate that knowledge for the purposes of implementing scientific, economic, environmental, educational, or political policies. This course will give students insight into ethical challenges to and approaches in doing data science.",
                    prerequisites: "None",
                    offered: "Every spring",
                  },
                  {
                    code: "PSYC 182 SC",
                    name: "Machine Learning Using Neural Signals",
                    description:
                      "This course teaches students the theory and practice of computational analyses of machine learning applied to neural signals for cognitive and neural classification. We will use real neural signals (e.g., spikes, EEG data, fMRI data, diffusion MRI data) in Python, Matlab, and R, so some computer programming experience is required (e.g., BIOL133L, PHYS108, PSYC123L, or equivalent). In this course, students will receive an overview of machine learning theory, an introduction to the concepts and practices of primary machine learning algorithms, and how to apply machine learning to information resulting from signal processing of neural signals. Each class meeting will involve theory and practical applications using active learning, giving students conceptual and computational capabilities that they can use for their own scholarly inquiry and computational applications.",
                    prerequisites:
                      "Prerequisites: Introduction to Computer Programming (preferably python or Matlab); Introduction to Probability and Statistics OR Calculus 2; Linear Algebra",
                    offered: "Every year",
                  },
                ].map((course, index) => (
                  <li key={index}>
                    <span
                      onClick={() => handleShowModal(course)}
                      style={{
                        cursor: "pointer",
                        textDecoration: "underline",
                      }}
                    >
                      {course.code} - {course.name}
                    </span>
                  </li>
                ))}
              </ul>

              <p>
                <strong>Physics</strong>
              </p>
              <ul>
                {[
                  {
                    code: "PHYS 178 KS",
                    name: "Biophysics",
                    description:
                      "An examination of biological systems from the point of view of classical physics, including mechanics, thermodynamics, and electromagnetism. Topics may include molecular diffusion, low-Reynolds number hydrodynamics, cooperative transitions in biomolecules, the mechanism of nerve impulses, the physics of vision and hearing, and principles of medical imaging and radiation therapy.",
                    prerequisites:
                      "BIOL 043L , or , or BIOL042L KS ; CHEM 014L and CHEM 015L , or and CHEM 015L , or CHEM 029L , or CHEM042L KS ; and PHYS 030L , PHYS 031L or PHYS 033L , PHYS 034L , or permission of instructor.",
                    offered: "Every other spring",
                  },
                ].map((course, index) => (
                  <li key={index}>
                    <span
                      onClick={() => handleShowModal(course)}
                      style={{
                        cursor: "pointer",
                        textDecoration: "underline",
                      }}
                    >
                      {course.code} - {course.name}
                    </span>
                  </li>
                ))}
              </ul>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>

        <div className="space1" />

        <h2>4 Year Plan</h2>
        <div className="four-year-plan">
          <p>
            Access and copy the sheet:{" "}
            <a
              href={spreadsheets[currentSheetIndex].shareLink}
              target="_blank"
              rel="noopener noreferrer"
            >
              {spreadsheets[currentSheetIndex].name}
            </a>
          </p>
          <iframe
            src={spreadsheets[currentSheetIndex].embedLink}
            width="100%"
            height="300"
            // title="Google Sheets Viewer"
          ></iframe>
          <div style={{ marginTop: "1px", textAlign: "center" }}>
            <button
              onClick={handlePrevious}
              variant="secondary"
              style={{ marginRight: "10px" }}
              className="prev-next-button"
            >
              &lt; Previous
            </button>
            <button
              onClick={handleNext}
              variant="secondary"
              className="prev-next-button"
            >
              Next &gt;
            </button>
          </div>
        </div>
        <div className="space1" />
      </Container>

      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton className="modal-header">
          <Modal.Title>{selectedCourse?.name}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="modal-body">
          <p>
            <strong>Code:</strong> {selectedCourse?.code}
          </p>
          <p>
            <strong>Description:</strong> {selectedCourse?.description}
          </p>
          {selectedCourse?.prerequisites && (
            <p>
              <strong>Prerequisite(s):</strong> {selectedCourse.prerequisites}
            </p>
          )}
          {selectedCourse?.offered && (
            <p>
              <strong>Offered:</strong> {selectedCourse.offered}
            </p>
          )}
        </Modal.Body>
        <Modal.Footer className="modal-footer">
          <Button className="modal-button" onClick={handleCloseModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showFirstSteps} onHide={handleCloseModal}>
        <Modal.Header closeButton className="modal-header">
          <Modal.Title>First Steps</Modal.Title>
        </Modal.Header>
        <Modal.Body className="modal-body">
          <ol>
            <li>
              Consider that <strong>you must take Calc I and II</strong>, and an
              introductory coding class<strong> in Python</strong>.
            </li>
            <li>
              Otherwise, there is no rigid order for completing these courses.
            </li>
            <li>
              Also note that all of the statistics courses have prerequisites.
            </li>
          </ol>
        </Modal.Body>
        <Modal.Footer className="modal-footer">
          <Button className="modal-button" onClick={handleCloseModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showNumCourses} onHide={handleCloseModal}>
        <Modal.Header closeButton className="modal-header">
          <Modal.Title>Total Number of Courses</Modal.Title>
        </Modal.Header>
        <Modal.Body className="modal-body">
          <p>
            A minor in Data Science requires a minimum of seven courses, in
            addition to Calculus I and II.
          </p>
        </Modal.Body>
        <Modal.Footer className="modal-footer">
          <Button className="modal-button" onClick={handleCloseModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showUnlisted} onHide={handleCloseModal}>
        <Modal.Header closeButton className="modal-header">
          <Modal.Title>Unlisted Courses</Modal.Title>
        </Modal.Header>
        <Modal.Body className="modal-body">
          <p>
            If a course is <strong>not</strong> listed here, then you{" "}
            <strong>must get it approved</strong> by Prof. Ou or Prof. Spezio.
            This only applies to the Introductory Coding, Probability and
            Statistics, and Linear Algebra requirements. There are no alternate
            courses for the other course areas.
          </p>
        </Modal.Body>
        <Modal.Footer className="modal-footer">
          <Button className="modal-button" onClick={handleCloseModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <Footer />
    </div>
  );
};
